import React from "react";
import { CTAButton } from "./CTAButton";
export function Distinction() {
  return <section className="w-full bg-white px-4 py-16 sm:py-20" data-id="element-104" data-mp="1jn813slt1qsn">
      <div className="mx-auto max-w-3xl text-center" data-id="element-105" data-mp="1jkv8mlif7y1c">
        <p className="text-xs font-bold uppercase tracking-[0.14em] text-gold-dark sm:text-sm" data-id="element-106" data-mp="1yc43b916k9lc">Here's the important distinction</p>
        <h2 className="mt-3 font-serif text-[30px] font-bold leading-[1.12] text-navy sm:text-4xl md:text-5xl" data-id="element-107" data-mp="1tjjbgd1u46kg">
          The problem isn't necessarily a lack of nutritional knowledge.
        </h2>
        <p className="mx-auto mt-6 max-w-2xl rounded-2xl bg-gold-light px-5 py-5 font-serif text-xl font-bold leading-snug text-navy sm:text-2xl" data-id="element-108" data-mp="23adznmyn5g8j">
          Sometimes, the missing piece is a practical system for organizing the information you already use.
        </p>

        <div className="mt-8 space-y-4 text-left text-[17px] leading-relaxed text-muted sm:text-center sm:text-lg" data-id="element-109" data-mp="mvw1xaxhj4b9">
          <p data-id="element-110" data-mp="hyw39l2yt3u6">
            Instead of another lengthy educational document, I organized the major stages of insulin resistance nutrition care
            into <strong className="text-ink" data-id="element-111" data-mp="1ggeb52qpsfp2">six practical volumes</strong> and <strong className="text-ink" data-id="element-112" data-mp="1ggwd8g025o4w">five specialized tools</strong>.
          </p>
          <p data-id="element-113" data-mp="1kh6mc1j5cunz">Each volume focuses on a different part of the workflow. Each tool serves a specific organizational purpose.</p>
          <p data-id="element-114" data-mp="1pat05x11r4ld">
            Together, they form a practical clinical reference system you can <strong className="text-ink" data-id="element-115" data-mp="1u79mqmsllawc">consult, print, and adapt</strong>{" "}
            to your existing professional workflow.
          </p>
        </div>

        <div className="mt-10" data-id="element-116" data-mp="245fp15ibgj1q">
          <CTAButton label="I want a clearer approach to insulin resistance nutrition care" note="One-Time Payment of $27 USD · Instant Digital Access · 7-Day Money-Back Guarantee" data-id="element-117" data-mp="247a9yjtl8b5t" />
        </div>
      </div>
    </section>;
}